(()=>{'use strict';
/* Collection filter drawer */
const form=document.getElementById('collectionFilters');
if(form){
  const drawer=document.getElementById('vbsFilters'),ov=form.querySelector('.vbs-overlay');
  const set=open=>{
    if(!drawer)return;
    drawer.classList.toggle('is-open',open);drawer.setAttribute('aria-hidden',String(!open));
    if(ov){ov.hidden=false;requestAnimationFrame(()=>ov.classList.toggle('is-open',open));
      if(!open)setTimeout(()=>{if(!ov.classList.contains('is-open'))ov.hidden=true},300)}
    document.documentElement.classList.toggle('vb-nav-lock',open);
  };
  document.addEventListener('click',e=>{
    if(e.target.closest('[data-vbs-open]')){e.preventDefault();set(true)}
    else if(e.target.closest('[data-vbs-close]')){e.preventDefault();set(false)}
  });
  document.addEventListener('keydown',e=>{if(e.key==='Escape')set(false)});
}
/* Bring active circle / size chip into view */
document.querySelectorAll('.vbs-circles .is-on,.vbs-sizes-r .is-on').forEach(el=>{
  const box=el.parentElement;if(box&&box.scrollWidth>box.clientWidth)box.scrollLeft=el.offsetLeft-box.clientWidth/2+el.offsetWidth/2;
});
/* Mobile menu: opening one accordion item closes its siblings */
document.querySelectorAll('.vbm details').forEach(d=>d.addEventListener('toggle',()=>{
  if(!d.open)return;
  const par=d.parentElement;
  par.querySelectorAll(':scope > details[open]').forEach(o=>{if(o!==d)o.open=false});
}));

/* Product gallery: slider, thumbs, hover-zoom, lightbox, variant sync */
(()=>{
const g=document.querySelector('[data-vb-gallery]');if(!g)return;
const track=g.querySelector('.vb-gal-track');if(!track)return;
const slides=[...track.children],thumbs=[...g.querySelectorAll('[data-gal-thumb]')];
const prev=g.querySelector('[data-gal-prev]'),next=g.querySelector('[data-gal-next]'),count=g.querySelector('[data-gal-count]');
const reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
let cur=0,lock=0;
const mark=i=>{
  cur=i;
  slides.forEach((s,k)=>{s.classList.toggle('is-active',k===i);if(k!==i)s.classList.remove('is-zoom')});
  thumbs.forEach((t,k)=>{t.classList.toggle('is-active',k===i);t.setAttribute('aria-selected',String(k===i));
    if(k===i){const b=t.parentElement;b.scrollTo({left:t.offsetLeft-b.clientWidth/2+t.offsetWidth/2,behavior:reduce?'auto':'smooth'})}});
  if(count)count.textContent=(i+1)+' / '+slides.length;
  if(prev)prev.disabled=i===0;if(next)next.disabled=i===slides.length-1;
};
const go=i=>{
  i=Math.max(0,Math.min(slides.length-1,i));
  lock=Date.now()+600;mark(i);
  track.scrollTo({left:i*track.clientWidth,behavior:reduce?'auto':'smooth'});
};
let raf=0;
track.addEventListener('scroll',()=>{
  if(Date.now()<lock)return;cancelAnimationFrame(raf);
  raf=requestAnimationFrame(()=>{const i=Math.round(track.scrollLeft/track.clientWidth);if(i!==cur)mark(i)});
},{passive:true});
prev&&prev.addEventListener('click',()=>go(cur-1));
next&&next.addEventListener('click',()=>go(cur+1));
thumbs.forEach((t,k)=>t.addEventListener('click',()=>go(k)));
g.querySelector('.vb-gal-stage').addEventListener('keydown',e=>{
  if(e.key==='ArrowLeft'){e.preventDefault();go(cur-1)}else if(e.key==='ArrowRight'){e.preventDefault();go(cur+1)}
});
mark(0);
/* hover zoom (mouse only) */
if(matchMedia('(hover:hover) and (pointer:fine)').matches&&!reduce){
  slides.forEach(s=>{
    if(!s.querySelector('a[data-full]'))return;
    s.addEventListener('mouseenter',()=>s.classList.add('is-zoom'));
    s.addEventListener('mouseleave',()=>s.classList.remove('is-zoom'));
    s.addEventListener('mousemove',e=>{
      const r=s.getBoundingClientRect();
      s.style.setProperty('--zx',((e.clientX-r.left)/r.width*100)+'%');
      s.style.setProperty('--zy',((e.clientY-r.top)/r.height*100)+'%');
    });
  });
}
/* lightbox */
const fulls=slides.map(s=>{const a=s.querySelector('a[data-full]');return a?a.dataset.full:null});
let lb;
const build=()=>{
  lb=document.createElement('div');lb.className='vb-lb';lb.setAttribute('role','dialog');lb.setAttribute('aria-modal','true');
  lb.innerHTML='<img alt=""><button class="lb-x" type="button" aria-label="Close">×</button><button class="lb-p" type="button" aria-label="Previous">‹</button><button class="lb-n" type="button" aria-label="Next">›</button>';
  document.body.appendChild(lb);
  lb.addEventListener('click',e=>{
    if(e.target.closest('.lb-p'))step(-1);else if(e.target.closest('.lb-n'))step(1);else if(!e.target.matches('img'))close();
  });
};
const show=i=>{lb.querySelector('img').src=fulls[i];lb.dataset.i=i};
const step=d=>{let i=+lb.dataset.i;do{i=(i+d+slides.length)%slides.length}while(!fulls[i]);show(i);go(i)};
const open=i=>{if(!lb)build();show(i);requestAnimationFrame(()=>lb.classList.add('is-open'));document.documentElement.classList.add('vb-nav-lock')};
const close=()=>{if(!lb)return;lb.classList.remove('is-open');document.documentElement.classList.remove('vb-nav-lock')};
slides.forEach((s,k)=>{const a=s.querySelector('a[data-full]');if(a)a.addEventListener('click',e=>{e.preventDefault();open(k)})});
document.addEventListener('keydown',e=>{
  if(!lb||!lb.classList.contains('is-open'))return;
  if(e.key==='Escape')close();else if(e.key==='ArrowLeft')step(-1);else if(e.key==='ArrowRight')step(1);
});
/* variant -> its photo */
const sel=document.getElementById('VariantSelect');
if(sel)sel.addEventListener('change',()=>{
  const id=sel.selectedOptions[0]&&sel.selectedOptions[0].dataset.media;if(!id)return;
  const k=slides.findIndex(s=>s.dataset.mediaId===id);if(k>-1)go(k);
});
})();
})();
